import React from "react";
// COMPONENTS
import { revealProps } from "Components/WebsiteTheme/Reveal";
// STYLES
import { AboutHero } from "./AboutUs.style";
// IMAGES
import HeroPhoto from "Assets/Images/LandingPage/about-hero-student.jpg";

/** About hero (same frame as the Home hero). */
const AboutIntro = () => (
	<AboutHero className="sm_hero">
		<div className="sm_container sm_hero_inner">
			<div className="sm_hero_photo">
				<img src={HeroPhoto} alt="A student smiling at her laptop in class, with classmates working behind her" width="1000" height="732" fetchpriority="high" />
				<p className="sm_hero_tagline sm_hand" aria-hidden="true">
					Same Instruction.
					<br />
					<span className="sm_hand_line">More Engagement.</span>
				</p>
			</div>

			<div className="sm_hero_copy" {...revealProps("left")}>
				<p className="sm_eyebrow">About Subjects Master</p>
				<h1 className="sm_display">
					Built From a Simple Idea:
					<br />
					<span className="sm_accent">Learning Can Be Engaging</span>
				</h1>
				<p className="sm_h3 ah_subline">Without Taking Control Away From Teachers.</p>
				<p className="sm_lead">
					Subjects Master gives teachers the tools to turn their instructional content into interactive gaming study guides that engage students and provide meaningful learning insights.
				</p>
			</div>
		</div>
	</AboutHero>
);

export default AboutIntro;
